module.exports = __webpack_public_path__ + "HyperTip-96bdd13b9c225087580f2ae5f6a9c5a4.png";